import styled from "styled-components";

export type StyledReportParagraph = {
  width?: string;
  fontSize?: "small" | "medium" | "large";
  fontWeight?: string;
  textAlign?: "left" | "center" | "right";
};

const FONT_SIZE_MAP: { [fontSize: string]: string } = {
  small: "10px",
  medium: "14px",
  large: "20px",
};

export const StyledReportCellRow = styled.div`
  display: flex;
  align-items: top;
  justify-content: flex-start;
  margin-bottom: 5px;

  .cell-labelA {
    width: 15%;
  }

  .cell-labelB {
    width: 30%;
  }
`;

export const StyledReportParagraph = styled.p`
  width: ${({ width }: StyledReportParagraph) => width};
  font-size: ${({ fontSize }: StyledReportParagraph) =>
    fontSize ? FONT_SIZE_MAP[fontSize] : FONT_SIZE_MAP["medium"]};
  text-align: ${({ textAlign }: StyledReportParagraph) => textAlign || "left"};
  font-weight: ${({ fontWeight }: StyledReportParagraph) =>
    fontWeight || "400"};
  letter-spacing: 0.03em;
  max-width: 55%;
  overflow-wrap: break-word;
`;
